import React, { useEffect, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
import { dynamicFailed } from "../hooks/custom/useToast";
import { useLoader } from "../context/LoaderContext";
import { fetchGallery } from "../api/GalleryApi";
import { IBannerData, IGalleryData } from "../exports/interfaces";
import Album from "../components/gallery/Album";
import Banner from "../components/Banner";
import { fetchGalleryBanner } from "../api/BannerApi";

const AlbumPage = () => {
  const { setLoading } = useLoader();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const [gallery, setGallery] = useState<IGalleryData[]>([]);
  const [galleryBanner, setGalleryBanner] = useState<IBannerData[]>([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchGallery(), fetchGalleryBanner()])
      .then(([galleryData, galleryBannerData]) => {
        setGallery(galleryData);
        setGalleryBanner(galleryBannerData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  return (
    <>
      <Banner title="Gallery" bannerImage={galleryBanner?.[0]?.image?.[0]} />
      <Album gallery={gallery} />
    </>
  );
};

export default AlbumPage;
